export const scopeDescriptions = {
  'documents:read': 'Ver seus documentos e o status das assinaturas',
  'documents:write': 'Criar e enviar documentos para assinatura (pode consumir créditos de notificação do workspace)',
  'templates:read': 'Ver seus modelos de documentos',
  'templates:write': 'Criar e modificar seus modelos de documentos',
  'account:read': 'Ver o nome e as configurações do workspace',
  'webhooks:write': 'Alterar para onde e quais eventos de webhook são enviados e desativar a assinatura de webhook',
  openid: 'Confirmar sua identidade',
  profile: 'Ver seu nome',
  email: 'Ver seu endereço de e-mail',
  offline_access: 'Permanecer conectado e agir em seu nome quando você não estiver usando a Assinafy',
};

export const errorMessage = error => error?.response?.data?.message || 'Não foi possível concluir a operação. Tente novamente.';

export function isHttpUrl(value, httpsOnly = false) {
  try {
    const url = new URL(value);
    return (httpsOnly ? url.protocol === 'https:' : ['http:', 'https:'].includes(url.protocol)) && !!url.hostname && !url.username && !url.password && (!httpsOnly || !value.includes('#'));
  } catch { return false; }
}

export function clientPayload(form, editing = false) {
  const name = form.name.trim();
  const description = form.description.trim();
  const logo = form.logo_url.trim();
  const redirect_uris = [...new Set(form.redirect_uris.split('\n').map(uri => uri.trim()).filter(Boolean))];
  if (!name) throw new Error('Informe o nome do aplicativo.');
  if (/<[^>]*>/.test(name + description)) throw new Error('Nome e descrição não podem conter marcação HTML.');
  if (logo && !isHttpUrl(logo)) throw new Error('Informe uma URL http ou https válida para o logo.');
  if (!redirect_uris.length || redirect_uris.some(uri => !isHttpUrl(uri, true))) throw new Error('Informe ao menos uma URL de redirecionamento https válida, sem fragmento (#).');
  if (!form.allowed_scopes.length || form.allowed_scopes.some(scope => !scopeDescriptions[scope]) || !form.allowed_scopes.some(scope => scope !== 'offline_access')) throw new Error('Selecione ao menos uma permissão além de acesso offline.');
  return { name, description: description || null, logo_url: logo || null, redirect_uris, allowed_scopes: form.allowed_scopes, ...(!editing && { client_type: form.client_type }) };
}
